import { render, staticRenderFns } from "./TYKSPage.vue?vue&type=template&id=7a4f5ae0&scoped=true"
import script from "./TYKSPage.vue?vue&type=script&lang=js"
export * from "./TYKSPage.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TYKSPage.vue?vue&type=style&index=1&id=7a4f5ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4f5ae0",
  null
  
)

export default component.exports